import React, { useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface Props {
    value: string
    label?: string
    name: string
    isEditable?: boolean
    type: 'text'
    placeholder?: string
    disabled?: boolean;
    required?: boolean;
    tabIndex?: number;
    maxLength?: number;
    isInvalid?: boolean;
    invalidWarning?: string;
    controlId?: string;
    tooltipText?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onKeyDown?: () => void;
    isUSA?: boolean;
}

const zipCodeFormat = (value: string, isUSA?: boolean): string => {
    if(isUSA) {
    let val = value.replace(/[^0-9-]/g, '');
    val = val.replace(/-/g, '');
    if (val.length > 5) {
        val = val.slice(0, 5) + '-' + val.slice(5);
    }
    return val.slice(0, 10);
    }
    else
    {
    let val= value.toString().replace(/[^A-Za-z0-9\- ]/g, '');
    return val.toLocaleUpperCase();
    }
};

const TextInputWithZipCode = (props: Props) => {
    const {
        value,
        label,
        name,
        type,
        placeholder,
        onChange,
        onBlur,
        disabled,
        required,
        tabIndex,
        maxLength,
        isInvalid,
        invalidWarning,
        controlId,
        tooltipText = "Enter ZIP code in 12345 or 12345-6789 format.",
        onKeyDown,
        isUSA = true,
    } = props;

    const tooltip = <Tooltip id="tooltip">{tooltipText}</Tooltip>;
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <FloatingLabel
            controlId={controlId}
            label={
                <>
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </>
            }
            className="mb-3"
        >
            <OverlayTrigger
                placement="top"
                overlay={tooltip}
                show={showTooltip && (isUSA != false)}
            >
                <Form.Control
                    type="text"
                    placeholder={placeholder || " "}
                    name={name}
                    value={value ? zipCodeFormat(value,isUSA) : ""}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    onBlur={onBlur}
                    disabled={disabled}
                    required={required}
                    tabIndex={tabIndex}
                    maxLength={maxLength}
                    isInvalid={isInvalid}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    onMouseDown={() => setShowTooltip(false)}
                />
            </OverlayTrigger>
            {isInvalid && invalidWarning && (
                <Form.Control.Feedback type="invalid">
                    {invalidWarning}
                </Form.Control.Feedback>
            )}
        </FloatingLabel>
    );
};

TextInputWithZipCode.defaultProps = {
    value: '',
};

export default TextInputWithZipCode;
